(function() {
    'use strict';

    angular.module('notes').controller('NoteModalController', NoteModalController);

    NoteModalController.$inject = ['$uibModalInstance', 'dataObj', 'notesDataSrvc', 'notificationSrvc', 'notesMessagesConst', 'tagsDataSrvc'];

    function NoteModalController($uibModalInstance, dataObj, notesDataSrvc, notificationSrvc, notesMessagesConst, tagsDataSrvc) {
        var self = this;

        self.serverErrors = {
            text: [],
            tags: []
        }
        self.loading = false;

        self.orderData = dataObj.order;

        self.noteData = {
            text: "",
            object_id: self.orderData.pk,
            content_type: self.orderData.content_type_pk,
            tags: []
        }

        if (dataObj.note) {
            Object.assign(self.noteData, dataObj.note);
            self.noteData.tags = getTagPks(dataObj.note.tags);
        }

        self.tagOpts = [];

        self.formSubmit = formSubmit;
        self.modalClose = modalClose;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getTagOpts();
        }

        function getTagPks(tags) {
            var tagPks = [];
            for (var i = 0; i < (tags || []).length; i++) {
                var tag = tags[i];
                if (tag.hasOwnProperty('pk')) {
                    tagPks.push(tag['pk']);
                }
            }
            return tagPks;
        }

        function getTagOpts() {
            self.loading = true;
            return tagsDataSrvc.getFieldOpts()
                .$promise
                .then(
                    function (response) {
                        self.tagOpts = response;
                        return response;
                    }
                ).finally(
                    function (response) {
                        self.loading = false;
                        return response;
                    }
                );
        }


        function formSubmit() {
            if (!self.noteData.hasOwnProperty("pk")){
                notesDataSrvc.create(self.noteData)
                    .$promise.then(
                        function (response) {
                            $uibModalInstance.close();
                            notificationSrvc.notification("success", notesMessagesConst.add);
                        },
                        handleServerError
                )
            } else {
                notesDataSrvc.update({pk: self.noteData.pk}, self.noteData)
                    .$promise.then(
                        function (response) {
                            $uibModalInstance.close();
                            notificationSrvc.notification("success", notesMessagesConst.update);
                        },
                        handleServerError
                )
            }
        }

        function handleServerError(response) {
            self.serverErrors = response.data || {};
            var message = (response.data && response.data.detail) || notesMessagesConst.error;
            notificationSrvc.notification("error", message);
        }

        function modalClose() {
            self.order = null;
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();